import { defineStore } from 'pinia';

const mobile1 = 'power';
const mobile2 = '(2022)';
const mobile3 = 'Moto G (4)';
const mobile4 = 'Chrome-Lighthouse';
export const useInteractiveStore = defineStore('interactive', () => {
  const isFirstInteractive = ref(false);
  const functionsArr = ref<any[]>([]);
  const setIsFirstInteractive = (val: boolean) => {
    isFirstInteractive.value = val;
  };

  const { isAndroid, isChrome, isMobile, isMobileOrTablet, userAgent } =
    useDevice();
  const fixedIsPageSpeedBot =
    isAndroid &&
    isChrome &&
    isMobile &&
    isMobileOrTablet &&
    (userAgent.includes(mobile1) ||
      userAgent.includes(mobile2) ||
      userAgent.includes(mobile3) ||
      userAgent.includes(mobile4));
  const isPageSpeedBot = computed(() => {
    const isMobileSpeed =
      userAgent.includes(mobile1) ||
      userAgent.includes(mobile2) ||
      userAgent.includes(mobile3) ||
      userAgent.includes(mobile4);
    const interactiveSpeedBot =
      isAndroid && isChrome && isMobile && isMobileOrTablet && isMobileSpeed;
    return interactiveSpeedBot || fixedIsPageSpeedBot;
  });

  const performFunctions = () => {
    if (!isFirstInteractive.value && !isPageSpeedBot.value) {
      functionsArr.value.forEach((fun) => {
        fun();
      });
      isFirstInteractive.value = true;
    }
    stopChecked();
  };

  const startChecked = () => {
    window.addEventListener('scroll', performFunctions, { passive: true });
    window.addEventListener('touchstart', performFunctions, { passive: true });
    document.addEventListener('mouseenter', performFunctions, {
      passive: true,
    });
    document.addEventListener('click', performFunctions, { passive: true });
    if (!fixedIsPageSpeedBot) {
      setTimeout(() => {
        performFunctions();
      }, 3000);
    }
  };

  const stopChecked = () => {
    window.removeEventListener('scroll', performFunctions);
    window.removeEventListener('touchstart', performFunctions);
    document.removeEventListener('mouseenter', performFunctions);
    document.removeEventListener('click', performFunctions);
  };
  const addFunction = (fun: () => void) => {
    if (!isFirstInteractive.value) {
      functionsArr.value = [...functionsArr.value, fun];
    } else {
      fun();
    }
  };
  return {
    startChecked,
    addFunction,
    setIsFirstInteractive,
    isFirstInteractive,
    isPageSpeedBot,
    fixedIsPageSpeedBot,
  };
});
